'use client';
import Link from 'next/link';
import { Icon } from '../components/Icon';
export function DesignSpecButton() {
  return (
    <Link href="/docs" className="inline-flex items-center gap-1 rounded-md border px-2.5 py-1.5 text-sm hover:bg-gray-50 transition">
      <Icon name="settings" className="w-4 h-4" />
      <span>Design Spec</span>
    </Link>
  );
}
